<template>
  <roe-error-message :field="design.match_on_catch_up_contributions_yesno">
    <roe-radio-input
      v-model="design.$model.match_on_catch_up_contributions_yesno"
    ></roe-radio-input>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import RoeRadioInput from "@/components/_shared/inputs/RadioInput";
export default {
  name: "RoeEmployerMatchCatchUpRadio",
  components: { RoeRadioInput, RoeErrorMessage },
  props: {
    design: Object
  }
};
</script>
